import { apiFetch } from './api';

/** Les suppressions des 30 derniers jours, non restaurées : { data, jours, types }. */
export function getCorbeille({ type = '', q = '' } = {}) {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  if (q) params.set('q', q);
  const suite = params.toString();
  return apiFetch(`/corbeille${suite ? `?${suite}` : ''}`);
}

export function restaurerElement(lot) {
  return apiFetch(`/corbeille/${lot}/restaurer`, { method: 'POST' });
}

/** « Supprimer de la corbeille » : l'élément reste en base, n'est plus affiché. */
export function retirerDeLaCorbeille(lots) {
  return apiFetch('/corbeille/retirer', { method: 'POST', body: JSON.stringify({ lots }) });
}

/** Une ligne par changement de statut : qui, quand, quel statut. */
export function getHistoriqueStatuts(entite, id) {
  return apiFetch(`/corbeille/historique/${entite}/${id}`);
}
